import { ReactNode } from "react";
import cx from "classnames";

import styles from "../styles/FilterLayout.module.less";

type FilterLayoutProps = {
  panel: ReactNode;
  children: ReactNode;
};

const FilterLayout = ({ panel, children }: FilterLayoutProps) => {
  return (
    <div className={cx(styles.layout, !!panel && styles.withPanel)}>
      {panel && <div className={styles.panelColumn}>{panel}</div>}
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default FilterLayout;
